import { create } from 'zustand';
import { Event } from '../types/event.types';

/**
 * 🚀 Store de navigation Wouter
 * Store de navigation pour l'état des modales et transitions
 */

// 🔧 FIX PRD Navigation Phase 3c : Interface pour PreviewCardMap state
interface PreviewCardMapState {
  multiEvents: Event[];
  enrichedEvents?: any[];
  location: string;
  userLocation?: { lat: number; lng: number } | null;
  isMapView: boolean;
}

interface NavigationState {
  // État pour les modales d'événements
  eventModalState: {
    isMapView?: boolean;
    userLocation?: { lat: number; lng: number } | null;
    multiEvents?: Event[];
    enrichedEvents?: any[];
    showMultiEventModal?: boolean;
    location?: string;
    selectedOccurrence?: number;
    fromPage?: string;
    returnToMulti?: boolean;
  } | null;

  // 🔧 FIX PRD Navigation Phase 3c : État sauvegardé de PreviewCardMap
  // Permet de restaurer PreviewCardMap après history.back() depuis EventModal
  previewCardMapState: PreviewCardMapState | null;

  // État pour la navigation générale
  previousPath: string | null;

  // Actions
  setEventModalState: (state: NavigationState['eventModalState']) => void;
  clearEventModalState: () => void;
  setPreviousPath: (path: string) => void;

  // 🔧 FIX PRD Navigation Phase 3c : Actions pour PreviewCardMap
  setPreviewCardMapState: (state: PreviewCardMapState) => void;
  clearPreviewCardMapState: () => void;

  // Helper pour navigation back
  goBack: () => void;
}

export const useNavigationStore = create<NavigationState>((set, get) => ({
  eventModalState: null,
  previewCardMapState: null,
  previousPath: null,

  setEventModalState: (state) => set({ eventModalState: state }),

  clearEventModalState: () => set({ eventModalState: null }),

  setPreviousPath: (path) => set({ previousPath: path }),

  // 🔧 FIX PRD Navigation Phase 3c : Actions pour PreviewCardMap
  setPreviewCardMapState: (state) => {
    console.log('💾 [NavigationStore] Sauvegarde PreviewCardMap state:', {
      eventsCount: state.multiEvents.length,
      location: state.location
    });
    set({ previewCardMapState: state });
  },

  clearPreviewCardMapState: () => {
    console.log('🧹 [NavigationStore] Clear PreviewCardMap state');
    set({ previewCardMapState: null });
  },

  goBack: () => {
    const { previousPath } = get();
    if (previousPath) {
      window.history.pushState(null, '', previousPath);
      set({ previousPath: null });
    } else {
      window.history.back();
    }
  }
}));

// Hook helper pour compatibilité
export const useNavigationState = () => {
  const state = useNavigationStore((s) => s.eventModalState);
  const setState = useNavigationStore((s) => s.setEventModalState);
  const clear = useNavigationStore((s) => s.clearEventModalState);
  
  return { state, setState, clear };
};